export * from "@workspace/gamja-platform/hooks/useEffectivePass";
